var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header",class:'--is-' + _vm.textAlign + '-aligned'},[_c('h2',{staticClass:"section-header__title"},[_vm._t("title")],2),(_vm.$slots.description)?_c('div',{staticClass:"section-header__description"},[_vm._t("description")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }